import TweenLite from 'gsap/TweenLite';
import React from 'react';
import ReactDOM from 'react-dom';
import contentBlocker from '../../../general/js/content-blocker';
import BaseComponent from '../../../general/js/base-component';
import app from '../../../general/js/app';
import eventBus from '../../../general/js/event-bus';
import UrlHelper from '../../../general/js/url-helper';
import PredictiveSearch from '../../predictive-search/js/PredictiveSearch';
import {defaultFilters} from '../../lots-search/js/lots-search.component';
import {EVENT_OUTER_CLICK} from './header-events';

export default class HeaderSearchComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.onOpen = this.props.onOpen;

        this.predictive = this.refs.predictive;
        this.openBtn = this.refs.open;
        this.closeBtn = this.refs.close;

        this.searchUrl = app.getConfig('searchResultsUrl');
        this.hasBeenOpened = false;
        this.onSearchChange = this.onSearchChange.bind(this);
        this.headerOuterClickSubscription = null;
        this.onHeaderOuterClick = this.onHeaderOuterClick.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['predictive', 'open', 'close'];
    }

    static getRequiredProps() {
        return ['onOpen'];
    }

    init() {
        this.openBtn.addEventListener('click', () => {
            this.onOpen(this);
        });

        this.closeBtn.addEventListener('click', this.close.bind(this));

        ReactDOM.render(<PredictiveSearch inputRef={el => this.input = el}
                                          onChange={this.onSearchChange}/>, this.predictive);
    }

    onSearchChange(search) {
        let queryParams = {};
        if (search.query && search.query.length > 0) {
            queryParams.content = search.query;
        }
        if (search.queryType && search.queryType.length > 0) {
            queryParams.type = search.queryType;
        }
        window.location.href = this.getSearchUrl(queryParams);
    }

    getSearchUrl(params) {
        return UrlHelper.getUrlByParams(this.searchUrl, params, defaultFilters);
    }

    open() {
        if (!this.hasBeenOpened) {
            this.hasBeenOpened = true;
            this.tween = TweenLite.fromTo(this.element, 0.2, {width: '0%'}, {
                width: '100%',
                paused: true,
                onComplete: () => {
                    if (this.input) {
                        this.input.focus();
                    }
                },
                onReverseComplete: () => {
                    this.element.classList.remove('is-opened');
                    TweenLite.set(this.element, {width: 'auto'});
                }
            });
        }
        this.element.classList.add('is-opened');
        this.tween.play();

        if (!app.isDesktop) {
            contentBlocker.block('search', true);
        }

        this.headerOuterClickSubscription = eventBus.addListener(EVENT_OUTER_CLICK, this.onHeaderOuterClick);
    }

    onHeaderOuterClick(e) {
        this.close();
    }

    close() {
        this.tween.reverse();
        contentBlocker.unblock('search');
        this.headerOuterClickSubscription.remove();
    }
}



// WEBPACK FOOTER //
// ./app/components/header/js/header-search.component.js